export default "__VITE_ASSET__De7M7LYS__"